import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Theme } from "../../../theme";
import { AppBar, Toolbar, Hidden, IconButton, Badge } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { Link } from "react-router-dom";
import clsx from "clsx";

import NotificationsIcon from "@material-ui/icons/NotificationsOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import InputIcon from "@material-ui/icons/Input";

const StyledSection = styled.section`
  ${({ theme }: { theme: Theme }) => {
    return css`
      .root {
        background-color: #333;
        box-shadow: none;
      }
      .flexGrow {
        flex-grow: 1;
      }
      .signOutButton {
        margin-left: ${theme.spacing(1)}px;
      }
    `;
  }};
`;

export interface TopbarProps {
  notifs: string[];
  onLogoutOpen: () => void;
  [key: string]: any;
}

const Topbar: React.FC<TopbarProps> = props => {
  const { notifs, className, onSidebarOpen, ...rest } = props;

  const theme: Theme = useTheme();

  return (
    <>
      <StyledSection theme={theme}>
        <AppBar {...rest} className={clsx("root", className)}>
          <Toolbar>
            <Link to="/">
              <img
                alt="Logo"
                src="/images/logos/dcmWhite.svg"
                width={60}
                height={25}
              />
            </Link>
            <div className="flexGrow" />
            <Hidden mdDown>
              <IconButton color="inherit">
                <Badge
                  badgeContent={notifs.length}
                  color="primary"
                  variant="dot"
                >
                  <NotificationsIcon />
                </Badge>
              </IconButton>
              <IconButton
                className="signOutButton"
                color="inherit"
                onClick={e => {
                  e.preventDefault();
                  console.log("clicked");

                  props.onLogoutOpen();
                }}
              >
                <InputIcon />
              </IconButton>
            </Hidden>
            <Hidden lgUp>
              <IconButton color="inherit" onClick={onSidebarOpen}>
                <MenuIcon />
              </IconButton>
            </Hidden>
          </Toolbar>
        </AppBar>
      </StyledSection>
    </>
  );
};

export default Topbar;
